import React, { useEffect, useState } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { DefaultTemplate } from 'views/templates/DefaultTemplate';
import { useParams } from 'react-router-dom';
import { Splash } from 'views/components/molecules/Splash';
import { useIntl } from 'react-intl';
import { localeIds } from 'locals';
import { setExceptionError } from 'stores/errorSlice';
import { useAppDispatch } from 'stores/type';
import { ROUTER_PATH } from 'views/constants';
import { InvitationDomain } from 'models/Invitation';
import { Invitation } from 'models/Invitation/type';
import { InvitationPageLayout } from 'views/layouts/InvitationPageLayout';
import { UnavailableInvitationPageLayout } from 'views/layouts/UnavailableInvitationPageLayout';
import { getRequestPath } from 'utils/string';

interface InvitationPageParams {
  invitationToken: string;
}

export const InvitationPage: React.FC = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const intl = useIntl();
  const { invitationToken } = useParams<InvitationPageParams>();
  const [loading, setLoading] = useState<boolean>(true);
  const [invitation, setInvitation] = useState<Invitation | undefined>(
    undefined
  );

  useEffect(() => {
    const getDetail = async () => {
      InvitationDomain.detail(invitationToken)
        .then((result) => {
          setLoading(false);

          if (result.isFailure()) {
            return;
          }

          setInvitation(result.value);
        })
        .catch((e) => {
          dispatch(setExceptionError(e));
        });
    };

    getDetail();
  }, [invitationToken]);

  if (!invitationToken) {
    return <Redirect to={ROUTER_PATH.home} />;
  } else if (!loading) {
    if (invitation) {
      return (
        <DefaultTemplate
          headerText={intl.formatMessage({
            id: localeIds.invitation.headerTitle,
          })}
        >
          <InvitationPageLayout
            invitation={invitation}
            onLogin={() => {
              history.push(
                getRequestPath(ROUTER_PATH.login, {
                  invitation_token: invitation.token,
                })
              );
            }}
            onSignUp={() => {
              history.push(
                getRequestPath(ROUTER_PATH.signUp, {
                  invitation_token: invitation.token,
                })
              );
            }}
          />
        </DefaultTemplate>
      );
    } else {
      return (
        <DefaultTemplate
          headerText={intl.formatMessage({
            id: localeIds.invitation.headerTitle,
          })}
        >
          <UnavailableInvitationPageLayout
            onBack={() => {
              history.push(ROUTER_PATH.home);
            }}
          />
        </DefaultTemplate>
      );
    }
  } else {
    return (
      <DefaultTemplate headerText="">
        <Splash />
      </DefaultTemplate>
    );
  }
};
